import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'ta',
  months: [
    'ஜனவரி',
    'பிப்ரவரி',
    'மார்ச்',
    'ஏப்ரல்',
    'மே',
    'ஜூன்',
    'ஜூலை',
    'ஆகஸ்ட்',
    'செப்டம்பர்',
    'அக்டோபர்',
    'நவம்பர்',
    'டிசம்பர்',
  ],
  monthsShort: ['ஜன', 'பிப்', 'மார்ச்', 'ஏப்', 'மே', 'ஜூன்', 'ஜூலை', 'ஆக', 'செப்', 'அக்', 'நவ', 'டிச'],
  weekdays: [
    'ஞாயிறுக்கிழமை',
    'திங்கட்கிழமை',
    'செவ்வாய்க்கிழமை',
    'புதன்கிழமை',
    'வியாழக்கிழமை',
    'வெள்ளிக்கிழமை',
    'சனிக்கிழமை',
  ],
  weekdaysMin: ['ஞா', 'தி', 'செ', 'பு', 'வி', 'வெ', 'ச'],
  weekdaysShort: ['ஞாயி', 'திங்', 'செவ்', 'புதன்', 'வியா', 'வெள்', 'சனி'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'D/M/YYYY',
    LL: 'D MMMM, YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM, YYYY, HH:mm',
    'LLL-Y': 'D MMMM, HH:mm',
    LLLL: 'dddd, D MMMM, YYYY, HH:mm',
    'LLLL-Y': 'dddd D MMMM, HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM, YYYY',
    'll-Y': 'D MMM',
    'll-D': 'MMM YYYY',
    lll: 'D MMM, YYYY, h:mm A',
    'lll-Y': 'D MMM, h:mm A',
    llll: 'ddd, D MMM, YYYY, h:mm A',
    'llll-Y': 'ddd, D MMM, h:mm A',
    'll-Y+w': 'ddd, D MMM',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY, HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s ஆண்டிற்கு முன்', other: '%s ஆண்டுகளுக்கு முன்' },
    M: { one: '%s மாத. முன்', other: '%s மாத. முன்' },
    w: { one: '%s வார. முன்', other: '%s வார. முன்' },
    d: { one: '%s நாளுக்கு முன்', other: '%s நாட்களுக்கு முன்' },
    h: { one: '%s மணி. முன்', other: '%s மணி. முன்' },
    m: { one: '%s நிமி. முன்', other: '%s நிமி. முன்' },
    s: { one: '%s விநா. முன்', other: '%s விநா. முன்' },
  },
  future: {
    y: { one: '%s ஆண்டில்', other: '%s ஆண்டுகளில்' },
    M: { one: '%s மாத.', other: '%s மாத.' },
    w: { one: '%s வார.', other: '%s வார.' },
    d: { one: '%s நாளில்', other: '%s நாட்களில்' },
    h: { one: '%s மணி.', other: '%s மணி.' },
    m: { one: '%s நிமி.', other: '%s நிமி.' },
    s: { one: '%s விநா.', other: '%s விநா.' },
  },
  pastLong: {
    y: { one: '%s ஆண்டிற்கு முன்', other: '%s ஆண்டுகளுக்கு முன்' },
    M: { one: '%s மாதத்துக்கு முன்', other: '%s மாதங்களுக்கு முன்' },
    w: { one: '%s வாரத்திற்கு முன்', other: '%s வாரங்களுக்கு முன்' },
    d: { one: '%s நாளுக்கு முன்', other: '%s நாட்களுக்கு முன்' },
    h: { one: '%s மணிநேரம் முன்', other: '%s மணிநேரம் முன்' },
    m: { one: '%s நிமிடத்திற்கு முன்', other: '%s நிமிடங்களுக்கு முன்' },
    s: { one: '%s விநாடிக்கு முன்', other: '%s விநாடிகளுக்கு முன்' },
  },
  futureLong: {
    y: { one: '%s ஆண்டில்', other: '%s ஆண்டுகளில்' },
    M: { one: '%s மாதத்தில்', other: '%s மாதங்களில்' },
    w: { one: '%s வாரத்தில்', other: '%s வாரங்களில்' },
    d: { one: '%s நாளில்', other: '%s நாட்களில்' },
    h: { one: '%s மணிநேரத்தில்', other: '%s மணிநேரத்தில்' },
    m: { one: '%s நிமிடத்தில்', other: '%s நிமிடங்களில்' },
    s: { one: '%s விநாடியில்', other: '%s விநாடிகளில்' },
  },
  abbr: {
    y: { one: '%sஆ.', other: '%sஆ.' },
    M: { one: '%sமா', other: '%sமா' },
    w: { one: '%sவா', other: '%sவா' },
    d: { one: '%sநா', other: '%sநா' },
    h: { one: '%sமநே', other: '%sமநே' },
    m: { one: '%s நிமி', other: '%s நிமி' },
    s: { one: '%sவி', other: '%sவி' },
  },
  full: {
    y: { one: '%s ஆண்டு', other: '%s ஆண்டுகள்' },
    M: { one: '%s மாதம்', other: '%s மாதங்கள்' },
    w: { one: '%s வாரம்', other: '%s வாரங்கள்' },
    d: { one: '%s நாள்', other: '%s நாட்கள்' },
    h: { one: '%s மணிநேரம்', other: '%s மணிநேரங்கள்' },
    m: { one: '%s நிமிடம்', other: '%s நிமிடங்கள்' },
    s: { one: '%s விநாடி', other: '%s விநாடிகள்' },
  },
  justNow: 'இப்போதுதான்',
  yesterday: 'நேற்று',
  today: 'இன்று',
  tomorrow: 'நாளை',
  weekStart: 0,
  timeRange: '%$1s – %$2s',
  timeZone: '%$1s %$2s',
  timePref: {},
  timeRangeStyles: {
    yl: { start: 'D MMMM, YYYY', end: 'D MMMM, YYYY' },
    'yl-1': { start: 'D MMMM', end: 'D MMMM, YYYY' },
    ml: { start: 'D MMMM', end: 'D MMMM' },
    'ml-1': { start: 'D', end: 'D MMMM, YYYY' },
    dl: { start: 'D', end: 'D MMMM' },
    y: { start: 'D MMM, YYYY', end: 'D MMM, YYYY' },
    'y-1': { start: 'D MMM', end: 'D MMM, YYYY' },
    m: { start: 'D MMM', end: 'D MMM' },
    'm-1': { start: 'D', end: 'D MMM, YYYY' },
    d: { start: 'D', end: 'D MMM' },
    Y: { start: 'ddd, D MMM, YYYY', end: 'ddd, D MMM, YYYY' },
    'Y-1': { start: 'ddd, D MMM', end: 'ddd, D MMM, YYYY' },
    M: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    D: { start: 'ddd, D MMM', end: 'ddd, D MMM' },
    yt: { start: 'D MMM, YYYY, HH:mm', end: 'D MMM, YYYY, HH:mm' },
    mt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    dt: { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm' },
    t: { start: 'HH:mm', end: 'HH:mm' },
    'yt+to': { start: 'D MMM, YYYY, HH:mm', end: 'D MMM, YYYY, HH:mm ([GMT]Z)' },
    'mt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    'dt+to': { start: 'D MMM, HH:mm', end: 'D MMM, HH:mm ([GMT]Z)' },
    't+to': { start: 'HH:mm', end: 'HH:mm ([GMT]Z)' },
  },
};
const localeName: LocaleName = 'ta';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  ordinal: (n) => `${n}`,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
